// Shared layout for the unauthenticated pages.

type AuthShellProps = {
  children: React.ReactNode;
};

type AuthHeadingProps = {
  title: string;
  description: string;
};

export function AuthShell({ children }: AuthShellProps) {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-bg-main py-8">
      <div className="mx-auto flex w-[560px] flex-col justify-center space-y-6 px-8">
        {children}
      </div>
    </div>
  );
}

export function AuthHeading({ title, description }: AuthHeadingProps) {
  return (
    <div className="flex flex-col space-y-2 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
}
